import * as React from 'react';

import Spinner from 'components/common/Spinner';
import useCurrentUser from 'hooks/useCurrentUser';
import useOwnerAssignee from 'security-app/components/SecurityEvents/Alerts/hooks/useOwnerTitles';

import AssigneeCell from '../../common/AssigneeCell';

type Props = {
  owner: string;
  highlightCurrentUser?: boolean;
};

const OwnerCell = ({ owner, highlightCurrentUser = false }: Props) => {
  const { data: assignee, isInitialLoading } = useOwnerAssignee(owner);
  const currentUser = useCurrentUser();
  const isCurrentUser = highlightCurrentUser && currentUser.id === owner;

  if (isInitialLoading) {
    return <Spinner />;
  }

  if (!assignee) {
    return <i>none</i>;
  }

  const displayAssignee = isCurrentUser ? { ...assignee, label: `Me (${assignee.label})` } : assignee;

  return <AssigneeCell assignee={displayAssignee} />;
};

export default OwnerCell;
